import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";
import { minDate } from "../../../Constants/Constants";

const UpdateProductDetailsModal = ({
  updateHandleChange,
  selectedRowsData,
  getData,
  setselectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [yardData, setYardData] = useState([]);
  const [storeYardId, setStoreYardId] = useState("");
  const [storeYardQty, setStoreYardQty] = useState("");
  const [yardProductData, setYardProductData] = useState([]);
  const product_detail_id = selectedRowsData?.id || "";
  const companyName = selectedRowsData.companyDetails?.company_name || "";
  const companyLocation = selectedRowsData.companyDetails?.location || "";
  const productName = selectedRowsData.productName?.size || "";
  const companyId = selectedRowsData?.company_id || "";
  const party = selectedRowsData?.partyName?.party_name || "";
  const material = selectedRowsData?.raw_material?.material_name || "";
  const materialId = selectedRowsData?.raw_material?.id || "";
  const partyId = selectedRowsData?.partyName?.id || "";
  const yard_details = selectedRowsData?.in_yard_qty_details || [];
  const [initialYardIds, setInitialYardIds] = useState([]);
  const [yardDetails, setYardDetails] = useState([
    { yard_id: "", p_incoming_date: "", in_yard_qty: "" },
  ]);

  const [yardDetailsQty, setYardDetailsQty] = useState([
    { yard_id: "", p_incoming_date: "", in_yard_qty: "" },
  ]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };
  function resetFileds() {
    setYardDetails([{ yard_id: "", p_incoming_date: "", in_yard_qty: "" }]);
    setYardDetailsQty([{ yard_id: "", p_incoming_date: "", in_yard_qty: "" }]);
    setselectedRowsData("");
  }

  useEffect(() => {
    if (selectedRowsData) {
      const list = yard_details?.map((item) => ({
        yard_id: item.yard_id,
        yard_name: item.yard_name,
        p_incoming_date: item.p_incoming_date,
        in_yard_qty: item.in_yard_qty,
      }));
      setYardDetailsQty(list);
      setInitialYardIds(
        selectedRowsData?.in_yard_qty_details?.map(
          (item, index) => item.yard_id
        )
      );
    }
  }, [selectedRowsData]);

  const getYardDataWithProduct = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/product-details/product-details-in-yard/${user_id}/${product_detail_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      if (result.data) {
        setYardProductData(result.data);
      } else {
        setYardProductData([]);
      }
    } else {
      setYardProductData([]);
    }
  };
  const handleAddFields = () => {
    if (selectedRowsData?.in_yard_qty_details?.length > 0) {
      setYardDetailsQty([
        ...yardDetailsQty,
        { yard_id: "", p_incoming_date: "", incoming: "" },
      ]);
    } else {
      setYardDetails([
        ...yardDetails,
        { yard_id: "", p_incoming_date: "", incoming: "" },
      ]);
    }
  };
  const handleChangeInput = (index, event) => {
    if (selectedRowsData?.in_yard_qty_details?.length > 0) {
      const values = [...yardDetailsQty];
      if (event.target.name === "yard_id") {
        values[index].yard_id = event.target.value;
      } else if (event.target.name === "p_incoming_date") {
        values[index].p_incoming_date = event.target.value;
      } else {
        values[index].in_yard_qty = event.target.value;
      }
      setYardDetailsQty(values);
    } else {
      const values = [...yardDetails];
      if (event.target.name === "yard_id") {
        values[index].yard_id = event.target.value;
      } else if (event.target.name === "p_incoming_date") {
        values[index].p_incoming_date = event.target.value;
      } else {
        values[index].in_yard_qty = event.target.value;
      }
      setYardDetails(values);
    }
  };
  const getYardData = async () => {
    setStoreYardId("");
    let BASE_URL =
      SERVER_URL + `/api/com-yard/single-company-yards/${user_id}/${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setYardData(result.data);
    } else {
      setYardData([]);
    }
  };

  useEffect(() => {
    if (companyId) {
      getYardDataWithProduct();
      getYardData();
    }
  }, [selectedRowsData, companyId]);

  useEffect(() => {
    if (yardProductData) {
      setStoreYardId(yardProductData.yard_id);
    }
  }, [yardData]);

  const updateAddProduct = async (e) => {
    e.preventDefault();
    const { id, quantity, product_name_id } = selectedRowsData;
    let BASE_URL =
      SERVER_URL + `/api/product-details/product-details-in-yard/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        product_name_id: product_name_id,
        in_yard_qty_details:
          selectedRowsData?.in_yard_qty_details?.length > 0
            ? yardDetailsQty
            : yardDetails,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        resetFileds();
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  const handleClose = (index) => {
    if (selectedRowsData?.in_yard_qty_details?.length > 0) {
      const values = [...yardDetailsQty];
      values.splice(index, 1);
      setYardDetailsQty(values);
    } else {
      const values = [...yardDetails];
      values.splice(index, 1);
      setYardDetails(values);
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateYardModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Product Details In Yard
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Update product Details</h4> */}
                    <form className="form-sample" onSubmit={updateAddProduct}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="company_name"
                              placeholder="company Name"
                              readOnly
                              value={`${companyName}, ${companyLocation}`}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="yard_quantity">Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              name="quantity"
                              id="yard_quantity"
                              placeholder="Quantity"
                              readOnly
                              value={selectedRowsData.quantity}
                              onChange={updateHandleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="product_name">Product Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="product_name"
                              id="product_name"
                              readOnly
                              value={productName}
                              onChange={updateHandleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="product_date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="product_date"
                              readOnly
                              min={minDate}
                              max={new Date().toISOString().split("T")[0]}
                              required
                              value={selectedRowsData.date}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        {selectedRowsData?.in_yard_qty_details?.length > 0
                          ? yardDetailsQty?.map((item, index) => {
                              const isInitialYardId =
                                item.yard_id &&
                                initialYardIds.includes(item.yard_id);
                              return (
                                <React.Fragment key={index}>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="in_yard">Yard</label>
                                      <select
                                        className="form-control"
                                        name="yard_id"
                                        id="in_yard"
                                        disabled={isInitialYardId}
                                        value={item.yard_id}
                                        onChange={(event) =>
                                          handleChangeInput(index, event)
                                        }
                                        required
                                      >
                                        <option value="">Select Yard</option>
                                        {yardData &&
                                          yardData?.length > 0 &&
                                          yardData?.map((item, index) => {
                                            return (
                                              <option
                                                key={index}
                                                value={item.id}
                                              >
                                                {item.yard_name}
                                              </option>
                                            );
                                          })}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="p_incoming_date">
                                        Incoming Date
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        name="p_incoming_date"
                                        id="p_incoming_date"
                                        max={
                                          new Date().toISOString().split("T")[0]
                                        }
                                        onChange={(event) =>
                                          handleChangeInput(index, event)
                                        }
                                        min={selectedRowsData.date}
                                        disabled={isInitialYardId}
                                        value={item.p_incoming_date}
                                        required
                                        autoComplete="off"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <label htmlFor="in_yard_qty">
                                        In Yard Quantity
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="in_yard_qty"
                                          id="in_yard_qty"
                                          placeholder="Enter quantity to place in yard"
                                          value={item.in_yard_qty}
                                          onChange={(event) =>
                                            handleChangeInput(index, event)
                                          }
                                          required
                                          autoComplete="off"
                                        />
                                        <span className="input-group-append ml-2">
                                          <div className="col-md-2">
                                            <button
                                              type="button"
                                              title="Remove"
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                              onClick={() => handleClose(index)}
                                              disabled={isInitialYardId}
                                            >
                                              <span className="mdi mdi-close-thick"></span>
                                            </button>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })
                          : yardDetails.map((item, index) => (
                              <React.Fragment key={index}>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label htmlFor="yard_name">Yard</label>
                                    <select
                                      className="form-control form-control-lg"
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                      name="yard_id"
                                      value={item.yard_id}
                                      id="yard_name"
                                      required
                                    >
                                      <option value="">Select Yard</option>
                                      {yardData &&
                                        yardData?.length > 0 &&
                                        yardData?.map((item, index) => (
                                          <option
                                            value={`${item.id}`}
                                            key={index}
                                          >{`${item.yard_name}`}</option>
                                        ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label htmlFor="p_incoming_date">
                                      Incoming Date
                                    </label>
                                    <input
                                      type="date"
                                      className="form-control"
                                      name="p_incoming_date"
                                      id="p_incoming_date"
                                      max={
                                        new Date().toISOString().split("T")[0]
                                      }
                                      min={selectedRowsData.date}
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                      value={item.p_incoming_date}
                                      required
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label htmlFor="in_yard_qty">
                                      In Yard Quantity
                                    </label>
                                    <div className="input-group">
                                      <input
                                        type="text"
                                        id="in_yard_qty"
                                        className="form-control"
                                        name="in_yard_qty"
                                        placeholder="Enter quantity to place in yard"
                                        value={item.in_yard_qty}
                                        onChange={(event) =>
                                          handleChangeInput(index, event)
                                        }
                                        required
                                        autoComplete="off"
                                      />
                                      <span className="input-group-append ml-2">
                                        <div className="col-md-2">
                                          {index > 0 ? (
                                            <button
                                              type="button"
                                              title="Remove"
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                              onClick={() => handleClose(index)}
                                            >
                                              <span className="mdi mdi-close-thick"></span>
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              disabled
                                              className="btn btn-outline-danger btn-rounded btn-icon"
                                            >
                                              <span className="mdi mdi-close-thick"></span>
                                            </button>
                                          )}
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                        <span className="input-group-append ml-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddFields}
                          >
                            Add More
                          </button>
                        </span>
                      </div>

                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateAddProduct}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProductDetailsModal;
